import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { EmailValidationRules, StorageKeys } from '@core/constants';
import { AlertService } from '@core/services/alert/alert.service';
import { FormValidationMessageModule } from '@shipmercury/mercury-ui';
import { RecaptchaComponent, RecaptchaModule } from 'ng-recaptcha-2';
import { ButtonDirective, ButtonLabel } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { lastValueFrom } from 'rxjs';
import { PublicBaseComponent } from 'src/app/public-base.component';

import { ForgotPasswordService } from './forgot-password.service';

@Component({
  selector: 'au-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  imports: [
    ReactiveFormsModule,
    InputTextModule,
    FormValidationMessageModule,
    ButtonDirective,
    RouterLink,
    RecaptchaModule,
    ButtonLabel,
  ],
})
export class ForgotPasswordComponent
  extends PublicBaseComponent
  implements AfterViewInit, OnDestroy
{
  @ViewChild('captchaRef') captchaRef!: RecaptchaComponent;
  @ViewChild('turnstileRef') turnstileRef?: ElementRef<HTMLDivElement>;
  form = new FormGroup({
    email: new FormControl<string>('', EmailValidationRules),
  });
  mercuryLogoPath = '../../assets/images/logo-original.svg';

  constructor(
    private forgotPasswordService: ForgotPasswordService,
    private router: Router,
    private alertService: AlertService
  ) {
    super();
    this.storageService.delete(StorageKeys.authUser);
    this.storageService.delete(StorageKeys.captchaResponse);
  }

  get email() {
    return this.form.get('email') as FormControl;
  }

  async ngAfterViewInit(): Promise<void> {
    if (!this.enableRecaptchaFlag) {
      return;
    }

    if (this.useTurnstile) {
      await this.initializeTurnstile(this.turnstileRef!, (token: string) =>
        this.resolved(token)
      );
    }
  }

  submitRequestWithCaptcha(): void {
    this.captchaRef.execute();
  }

  resolved(captchaResponse: any) {
    if (captchaResponse) {
      this.storageService.save(captchaResponse, StorageKeys.captchaResponse);
      if (!this.useTurnstile) {
        this.sendResetPasswordRequest();
        this.captchaRef.reset();
      } else {
        this.verifiedSuccessfully = true;
      }
    }
  }

  async sendResetPasswordRequest() {
    if (this.turnstileWidgetId) {
      this.verifiedSuccessfully = false;
      window.turnstile?.reset(this.turnstileWidgetId);
    }
    const res = await lastValueFrom(
      this.forgotPasswordService.sendRequest(this.email.value)
    );
    if (res && res.success) {
      this.router.navigateByUrl('forgot-password/success');
    } else if (res && !res.success && res.errorMessage) {
      this.alertService.error({ message: res.errorMessage });
    }
  }

  ngOnDestroy(): void {
    if (this.turnstileWidgetId) {
      window.turnstile?.remove(this.turnstileWidgetId);
      this.turnstileWidgetId = null;
    }
  }
}
